import React from 'react';

import './dot-logo.css';

interface DotLogoProps {
    width?: number;
}

export const DotLogo = ({ width = 175 }: DotLogoProps): JSX.Element => (
    <img
        className="dot-logo object-scale-down z-10"
        alt="Trqk logo"
        style={{ width }}
    />
);
